module.exports = __webpack_public_path__ + "static/l8-case-image-2-87efee8f1214dc333e782395134e1d14.jpg";